import { IPropertyAddressData } from './IPropertyAddressData';

export interface IPropertyAddressRequest {
  city: string;
  stateAbbreviation: string;
  streetAddress: string;
  unit?: string | null;
  zipCode: string;
}

export const convertIPropertyAddressDataToIPropertyAddressRequest = ({
  city,
  stateAbbreviation,
  streetAddress,
  unit,
  zipCode,
}: IPropertyAddressData): IPropertyAddressRequest => ({
  city,
  stateAbbreviation,
  streetAddress,
  unit,
  zipCode,
});
